import { Form, InputNumber } from 'antd';
import React from 'react';
import { ProtocoloProps } from './props';
import TextFilter from '../TextFilter';

const SelectProtocolo: React.FC<ProtocoloProps> = ({ setProtocolo }) => {
  const onChange = (values: any) => {
    setProtocolo(values);
    localStorage.setItem(`protocolo${window.location.pathname}`, values);
  };

  return (
    <>
      <Form.Item label={<TextFilter>Protocolo</TextFilter>} name="protocolo">
        <InputNumber onChange={onChange} min={0} type="number" style={{ width: '100%' }} />
      </Form.Item>
    </>
  );
};

export default SelectProtocolo;
